import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=699d48aa"
import script from "./Mark.vue?vue&type=script&lang=js"
export * from "./Mark.vue?vue&type=script&lang=js"
import style0 from "./Mark.vue?vue&type=style&index=0&id=699d48aa&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports